// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vjs-vtt-thumbnails {
  display: block;
  width: 100px;
}

.vjs-vtt-thumbnail-display {
  position: absolute;
  transition: transform .1s, opacity .2s;
  bottom: 85%;
  pointer-events: none;
  box-shadow: 0 0 7px rgba(0,0,0,.6);
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 0.3em;
}`, "",{"version":3,"sources":["webpack://./src/thumbnails/plugin.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,uCAAuC;EACvC,oBAAoB;AACtB","sourcesContent":[".vjs-vtt-thumbnails {\n  display: block;\n  width: 100px;\n}\n\n.vjs-vtt-thumbnail-display {\n  position: absolute;\n  transition: transform .1s, opacity .2s;\n  bottom: 85%;\n  pointer-events: none;\n  box-shadow: 0 0 7px rgba(0,0,0,.6);\n  border: 0.06666em solid #fff;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  border-radius: 0.3em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
